import { NAME } from './constants';

export const SET_ACTIVE_PAGE = `${NAME}/SET_ACTIVE_PAGE`;
export const SET_ACTIVE_PAGE_MULTIPLE = `${NAME}/SET_ACTIVE_PAGE_MULTIPLE`;
